import { useBlockProps } from "@wordpress/block-editor";

import AllInspectorSettings from "./InspectorControls";

import "../style.scss";

export default function Edit(props) {
  return (
    <>
      <AllInspectorSettings {...props} />
      <Content {...props} />
    </>
  );
}

export function Content({ attributes, isSave = false }) {
  const {
    name = "user_switcher",
    isRequired = false,
    label = "User switcher",
    id = "user-switcher",
    labelPosition = "left",
    size = "medium",
    enabledColor = "#2271b1",
    disabledColor = "#ccc",
    defaultChecked = true,
  } = attributes;

  const blockProps = isSave ? useBlockProps.save() : useBlockProps();

  return (
    <div {...blockProps}>
      <div
        className={`form-switcher-wrapper label-${labelPosition} size-${size}`}
        style={{
          "--switcher-enabled-color": enabledColor,
          "--switcher-disabled-color": disabledColor,
        }}
      >
        {label && (
          <label className="form-switcher-label">
            {label}
            {isRequired && <span className="required">*</span>}
          </label>
        )}
        <div className="form-switcher-toggle">
          <input
            type="checkbox"
            id={id}
            name={name}
            required={isRequired}
            className="form-switcher-input"
            checked={defaultChecked}
          />
          <label htmlFor={id} className="form-switcher-slider"></label>
        </div>
      </div>
    </div>
  );
}
